module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-footer",
    attrs: {
      "id": "footer"
    }
  }, [_vm._t("default", function() {
    return [_vm._v("Copyright © 2008-2022 天闻数媒科技（北京）有限公司, All Rights Reserved")]
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "href": "/static/dev/images/business_licence.png",
      "target": "_blank"
    }
  }, [_vm._v("经营证照")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-49cd660b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tw-footer.vue
// module id = 594
// module chunks = 1